module.exports = __webpack_public_path__ + "static/img/europeana.c61d362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/europeana.png
// module id = 5H6u
// module chunks = 0